import React, { useEffect, useState} from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Subtitle from '../Subtitle';
import Details from '../Details';
import Resume from '../Resume';
import ImgArt from '../ImgArt';
import {
  selectArticle,
  updateArticle,
  updateFeaturedArticle,
  updateSelectedArticle,
  shareListArticle,
  shareFeaturedArticle,
  shareSelectedArticle,
} from '../../../../../store/actions/ArticlesActions';
import { ARTICLES } from '../../../../../routes'
import './LandingArticle.scss';

function LandingArticle(props) {
  const {
    article,
  } = props;

  const [author, setAuthor] = useState('')
  
  useEffect(() => {
    if(article && article.createdBy && article.createdBy.typeUser === "lawyer") {
      setAuthor(article.lawyerUser); 
    }else {
      setAuthor('Contacta Abogado®');
    }
  }, [])

  const link = article && article.categories && `${ARTICLES}/${article.categories[0]}/${article.id}`;

  const articleDate = moment
    .unix(article && article.createdAt && article.createdAt._seconds)
    .utc()
    .format('D MMMM YYYY');

  return (
    <div className="landing-article">
      <div className="landing-article-wrapper">
        <div className="article-preview">
          <div className="article-preview-left">
            <Link to={link}>
              <ImgArt image={article && article.mainImage} styleImg="landing" />
            </Link>
          </div>
          <div className="article-name">
            <Link to={link}>
              <h4>{article && article.title}</h4>
            </Link>
          </div>

          <div className="article-preview-right">
            <Link to={link}> 
              <Details
                margin="normal"
                author={author}
                date={articleDate}
                time={article && article.readingTime}
                onLanding
              />
              <Resume
                margin="normal"
                text={article && article.articleSummary}
                idPost={article && article.id}
                category={article && article.categories[0]}
                title={article && article.title}
                onLanding
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateArticle: (article, articles, userId) =>
    dispatch(updateArticle(article, articles, userId)),
  selectArticle: (article) => dispatch(selectArticle(article)),
  updateFeaturedArticle: (article, userId) =>
    dispatch(updateFeaturedArticle(article, userId)),
  updateSelectedArticle: (article, userId) =>
    dispatch(updateSelectedArticle(article, userId)),
  shareListArticle: (article, articles) => dispatch(shareListArticle(article, articles)),
  shareFeaturedArticle: (article, articles) => dispatch(shareFeaturedArticle(article, articles)),
  shareSelectedArticle: (article, articles) => dispatch(shareSelectedArticle(article, articles)),
});

const mapStateToProps = (state) => ({
  userId: state.authClient.uid,
  articles: state.articlesReducer.articles,
  selectedArticle: state.articlesReducer.selectedArticle,
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingArticle);
